import React, { useEffect } from 'react';
import { trackPage } from 'helpers/analytics';
import { Switch, Route, Redirect } from 'react-router-dom';
import LoadingFullPage from 'components/molecules/LoadingFullPage';
import BlankLayout from 'components/layout/Blank';
import { MessageBlock } from '@getro/rombo';
import { Flex, Image, Box } from 'rebass/styled-components';
import { useClaimInfo } from './hooks/useClaimInfo';
import { Company } from './steps/company';
import Logo from '../../assets/icon-getro-intro.svg';
import { ClaimProfileSidebar } from './components/claimProfileSidebar';
import { SignUp } from './steps/signUp';
import { Profile } from './steps/profile';
import { Mismatch } from './steps/mismatch';
import { useConfirmClaim } from './hooks/useConfirmClaim';

const ClaimYourProfile = () => {
  const { network, isLoading, isError, company, isUserSignedIn, isEmailMatch, redirectToMismatch, isOnboarding } =
    useClaimInfo();
  const { isConfirmingUser } = useConfirmClaim(network, company, isOnboarding);

  useEffect(() => {
    trackPage();
  }, []);

  if (isLoading || isConfirmingUser) return <LoadingFullPage />;

  if (isError)
    return (
      <BlankLayout>
        <MessageBlock type="warning" title="Invalid link" content="Seems that your link is not valid or has expired." />
      </BlankLayout>
    );

  if (redirectToMismatch && network?.slug && company?.slug) {
    return <Redirect to={`/claim-your-profile/${network.slug}/company/${company.slug}/email_mismatch`} />;
  }

  return (
    <Flex flexDirection="row" justifyContent="space-between" height="100%">
      <Box
        sx={{
          width: ['120px', '120px', '160px'],
          height: ['30px', '30px', '40px'],
          position: 'absolute',
          top: ['24px', '24px', '40px'],
          left: ['16px', '16px', '40px'],
        }}
      >
        <Image src={Logo} />
      </Box>
      <Flex
        sx={{
          width: ['100%', '100%', 'calc(100% - 480px)'],
          justifyContent: 'center',
          height: '100%',
          position: 'relative',
        }}
      >
        <Switch>
          <Route exact path="/claim-your-profile/:networkSlug">
            <Company redirectToMismatch={redirectToMismatch} activeNetwork={network} />
          </Route>
          <Route exact path={['/claim-your-profile/:networkSlug/company/:employerSlug']}>
            <SignUp
              activeNetwork={network}
              company={company}
              isUserSignedIn={isUserSignedIn}
              isEmailMatch={isEmailMatch}
              isOnboarding={isOnboarding}
            />
          </Route>
          <Route exact path={['/claim-your-profile/:networkSlug/company/:employerSlug/profile']}>
            <Profile activeNetwork={network} company={company} isOnboarding={isOnboarding} />
          </Route>
          <Route exact path="/claim-your-profile/:networkSlug/company/:employerSlug/email_mismatch">
            <Mismatch activeNetwork={network} company={company} />
          </Route>
        </Switch>
      </Flex>
      <ClaimProfileSidebar networkName={network?.name} />
    </Flex>
  );
};

export default ClaimYourProfile;
